class LogService {
    info(text, data) {
        console.info(text, data);
    }

    error(text) {
        console.error(text);
    }
}

export { LogService }
